<template>
  <div></div>
</template>

<script>
export default {
  name: "AuthXPlan",
  data() {
    return {
      routes: [
        {
          name: "authx.index",
          label: "AuthX"
        },
        {
          name: "authx.plan",
          label: "Plan"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
